<template>
  <div
    class="text-center cursor-pointer"
    :class="classes"
    @click="download()"
  >
    <div
      v-if="isImage"
      class="w-32 h-24 mx-auto"
      :class="{
        'flex items-center justify-center': isLoadingImage || hasImageError
      }"
    >
      <mia-spinner
        v-if="isLoadingImage"
        class="w-4 h-4 text-orange-mia"
      />
      <mia-streamline-icon
        v-if="hasImageError"
        class="inline-block w-12 h-12 fill-current"
        src="picture-polaroid-landscape"
      />
      <img
        v-else
        class="object-contain"
        :src="previewUrl"
        @load="isLoadingImage = false"
        @error="onPreviewImageError"
      >
    </div>
    <template v-else-if="isPdf">
      <div
        v-if="hasPdfPreviewImage"
        class="relative flex justify-center"
        :class="{
          'h-24 items-center mx-auto': isLoadingImage
        }"
        :style="{
          width: isLoadingImage ? '150px' : 'auto'
        }"
      >
        <mia-spinner
          v-if="isLoadingImage"
          class="w-4 h-4 text-orange-mia"
        />
        <img
          v-show="!isLoadingImage"
          :src="pdfPreviewImage"
          width="150"
          @load="isLoadingImage = false"
          @error="onPreviewImageError"
        >
      </div>
      <mia-streamline-icon
        v-else
        class="inline-block w-12 h-12 fill-current"
        src="office-file-pdf"
      />
    </template>
    <mia-streamline-icon
      v-else
      class="inline-block w-12 h-12 fill-current"
      src="file-copyright-equal"
    />
  </div>
</template>

<script>
import get from 'lodash/get'
import Spinner from '@/components/ui/loader/Spinner.vue'

export default {
  name: 'MiaDatatableInlineEditColumn',

  components: {
    'mia-spinner': Spinner
  },

  props: {
    row: {
      type: Object,
      required: true
    },

    column: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    isLoadingImage: true,
    hasImageError: false
  }),

  computed: {
    classes() {
      return get(this.column, 'class', '')
    },

    mime() {
      return this.row.mime || this.row.item_filetype
    },

    id() {
      return this.row.id
    },

    key() {
      return this.row.key
    },

    isImage() {
      return typeof this.mime === 'string' && this.mime.match(/^image\//) !== null
    },

    isPdf() {
      return typeof this.mime === 'string' && this.mime === 'application/pdf'
    },

    isClickable() {
      return !this.row.import
    },

    previewUrl() {
      return this.row.previewUrl || this.getDownloadUrl()
    },

    hasPdfPreviewImage() {
      if (this.hasImageError) {
        return false
      }

      if (this.row.previewImage) {
        return true
      }

      return this.column.meta?.previewUrl !== undefined
    },

    pdfPreviewImage() {
      if (typeof this.column.meta?.previewUrl === 'function') {
        return this.column.meta.previewUrl(this.row)
      }

      if (typeof this.column.meta?.previewUrl === 'string') {
        return this.column.meta.previewUrl
      }

      return `${process.env.VUE_APP_PROVIDER}/car/pdfPreview/${this.row.previewImage}`
    }
  },

  methods: {
    getDownloadUrl() {
      if (typeof this.column.meta?.downloadUrl === 'function') {
        return this.column.meta.downloadUrl(this.row)
      }

      if (this.column.meta?.downloadUrl !== undefined) {
        return this.column.meta.downloadUrl
      }

      return `${window.baseUrl}/customers/getFile/${this.id}`
    },

    download() {
      if (!this.isClickable) return

      const clickHandler = this.column.meta?.onImageClick
      if (this.isImage && clickHandler) {
        clickHandler(this.id)
        return
      }

      window.open(this.getDownloadUrl())
    },

    onPreviewImageError() {
      this.isLoadingImage = false
      this.hasImageError = true
    }
  }
}
</script>
